export class Product {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.code = data.code;
    this.unitPrice = data.unitPrice;
    this.typeId = data.typeId;
    this.expirationTerm = data.expirationTerm;
    this.editDate = data.editDate;
  }
}
